import React from 'react';
import { toast } from 'react-toastify';
import CommunityImg from '../../Common/CommunityImg/CommunityImg';
import { default as EcoAllianceSupportImg } from '../../../images/eco-alliance-support.svg';
import { default as badge1 } from '../../../images/eco-alliance-badge.svg';
import { default as badge2 } from '../../../images/eco_packaging.svg';
import { default as badgeGif } from '../../../images/Eco-A.gif';
import { default as badgeBlack } from '../../../images/eco_packaging_black.svg';
import { default as badgeGreen } from '../../../images/eco_packaging_green.svg';
import { default as badgeWhite } from '../../../images/eco_packaging_white.svg';
import downloadEcoAllianceQrCertification from '../../../utils/downloadEcoAllianceQrCertification'
import './EcoAllianceSupport.scss';

const EcoAllianceSupport = () => {
  const EcoAllianceCode = `<a href="https://noissue.co/community/eco-alliance/" target="_blank" rel="noreferrer" rel="noopener">
  <img alt="Eco Alliance Badge" src="https://images.ctfassets.net/xmruv773lc7r/7iHSIdcOgBqG8KsVcw9wmm/46902df9b1125bfede12980be687dd7a/Eco-A.gif" height="300" width="300" />
</a>`;

  const copyText = () => {
    copyToClipboard(EcoAllianceCode);
  }

  const copyToClipboard = (content) => {
    const el = document.createElement('textarea');
    el.value = content;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    toast.info("Code copied to clipboard", {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    })
  };

  return (
    <div className="noissue__eco-alliance__support" >
      <div className="noissue__eco-alliance__support__heading">
        Sport Your Support
      </div>
      <div className="noissue__eco-alliance__support__subheading">
        Add an Eco-Alliance sticker to your storefront, whether it’s a physical store or online.
      </div>
      <div className="noissue__eco-alliance__support__image">
        <CommunityImg src={EcoAllianceSupportImg} alt="Eco Alliance Support" />
      </div>
      <div className="noissue__eco-alliance__support__section">
        <div className="noissue__eco-alliance__support__section__left">
          <div className="heading">
            On Your Store and Beyond
          </div>
          <div className="subheading">
            Showcase your badge on your physical storefront, or download it directly so you can sport your support on your packaging, social media, or in your emails. Get creative and show off your Eco-Alliance badge with the options below!
          </div>
          <div className="badges">
            <CommunityImg className="badges1" src={badge1} alt="badge 1" />
            <CommunityImg className="badges2" src={badge2} alt="badge 2" />
            <CommunityImg className="badges3" src={badgeWhite} alt="badge 3" />
            <CommunityImg className="badges4" src={badgeBlack} alt="badge 4" />
            <CommunityImg className="badges5" src={badgeGreen} alt="badge 5" />
          </div>
          <div className="button-section">
            {/* <button className="sticker-pack">Digital Sticker Pack</button> */}
            <button className="badge-bundle" onClick={downloadEcoAllianceQrCertification}>Eco-A Badge Bundle</button>
          </div>
        </div>
        <div className="noissue__eco-alliance__support__section__right">
          <div className="heading">
            On Your Website
          </div>
          <div className="subheading">
            Add the badge directly to your digital storefront (website/blogpost etc.). Spread the word and let your customers know that you use sustainable packaging products that are compostable, recycled, and/or reusable!
          </div>
          <div className="right-detail">
            <div className="code">
              <div className="code-content">
                <CommunityImg className="badges1" src={badgeGif} alt="badge 1" />
                <pre>
                    {EcoAllianceCode}
                </pre>
              </div>
              <div className="button-section">
                <button className="copy-code" onClick={copyText}>Copy Code</button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EcoAllianceSupport;